import { render } from "./KRCreationActivity.vue?vue&type=template&id=6a3c28c6"
import script from "./KRCreationActivity.vue?vue&type=script&lang=js"
export * from "./KRCreationActivity.vue?vue&type=script&lang=js"
script.render = render

export default script